import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getSensorEventUnarmedTitle = (record, translate) =>
  `${translate("event-unarmed.label")} ${record.id} `;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      title={<DynamicTitleWithTooltip getTitle={getSensorEventUnarmedTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
